import React, { useState, useEffect } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import styled from "styled-components"
import LogosHeader from "../components/logos-header"
import Intro from "../components/steps/intro"
import GetStarted from "../components/steps/get-started"
import NewUserTemplate from "../components/steps/new-user-template"
import ExistingUser from "../components/steps/existing-user"
import NewUserChoices from "../components/steps/new-user-choices"
import NewUserCustom from "../components/steps/new-user-custom"
import DeveloperHire from "../components/steps/developer-hire"

const Container = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 15vh 10px;
`

const Sidebar = styled.div`
  border: 1px solid blue;
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  max-width: 1200px;
`

const Content = styled.div``

const Main = styled.div``

const Option = styled.h1`
  font-size: 20px;
  height: 100%;
  background-color: #dcdcdc;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

const IndexPage = () => {
  const [step, setStep] = useState(0)
  const [header, setHeader] = useState("Welcome to shopify integration")

  useEffect(() => {
    setHeader(headers[step])
  }, [step])

  return (
    <Layout>
      <SEO title="Home" />
      <Container>
        <LogosHeader header={header} />
        {/* <!-- A little help for the Netlify post-processing bots --> */}
        <form
          name="existing-user"
          data-netlify="true"
          netlify-honeypot="bot-field"
          hidden
        >
          <input type="text" name="fullName" />
          <input type="email" name="email" />
          <input type="text" name="storeUrl" />
          <input type="text" name="phone" />
        </form>

        <form
          name="new-user-template"
          data-netlify="true"
          netlify-honeypot="bot-field"
          hidden
        >
          <input type="text" name="fullName" />
          <input type="text" name="businessName" />
          <input type="email" name="email" />
          <input type="text" name="phone" />
          <input type="text" name="template" />
          <input type="file" name="logo" />
        </form>

        <form
          name="new-user-custom"
          data-netlify="true"
          netlify-honeypot="bot-field"
          hidden
        >
          <input type="text" name="fullName" />
          <input type="text" name="businessName" />
          <input type="email" name="email" />
          <input type="text" name="phone" />
        </form>

        <Main>
          <Content>
            {step === 0 && <Intro setStep={setStep} />}
            {step === 1 && <GetStarted setStep={setStep} />}
            {step === 2 && <NewUserChoices setStep={setStep} />}
            {step === 3 && <NewUserCustom setStep={setStep} />}
            {step === 4 && <ExistingUser setStep={setStep} />}
          </Content>
        </Main>
      </Container>
    </Layout>
  )
}

export default IndexPage

const headers = [
  "Welcome to shopify integration",
  "Get Started",
  "Click an option",
  "Tell us about your business",
  "Tell us about your business",
  "Tell us more",
]
